import React, { ReactNode } from 'react'
import { Container, Title, Subtitle, Icon } from './CarpayPaymentFinished.style'
import { SupportedResultCodes } from '../types'

interface CarpayPaymentResultProps {
    children: ReactNode
}

const CarpayPaymentResult = ({ children }: CarpayPaymentResultProps) => {
    return <Container>{children}</Container>
}

const CarpayPaymentResultIcon = ({ variant, className }: { variant: SupportedResultCodes; className: string }) => (
    <Icon className={className} $variant={variant} />
)

const CarpayPaymentResultTitle = ({ children, variant }: { children: ReactNode; variant: SupportedResultCodes }) => (
    <Title $variant={variant}>{children}</Title>
)

const CarpayPaymentResultSubtitle = ({ children }: { children: ReactNode }) => <Subtitle>{children}</Subtitle>

CarpayPaymentResult.Icon = CarpayPaymentResultIcon
CarpayPaymentResult.Title = CarpayPaymentResultTitle
CarpayPaymentResult.Subtitle = CarpayPaymentResultSubtitle

export default CarpayPaymentResult
